import { useContext } from 'react';

import SubscriberContext, { SubscriberValues } from './context';

const useSubscriber = (): SubscriberValues => useContext(SubscriberContext);

export default useSubscriber;
